export const NATIVE_CURRENCY = "0x0000000000000000000000000000000000000000"

export const COVALENT_NFT_URL =
  "https://api.covalenthq.com/v1/80001/address/{walletAddress}/balances_v2/?quote-currency=USD&format=JSON&nft=true&no-nft-fetch=false&key={token}"
export const BACKEND_URL = "https://hackfs.ulad.dev/qr-code/claim"

export const COVALENT_TOKEN = "ckey_5c86efc78a4c45d5b7a46805e4b"

export const CURRENCIES: Record<string, string> = {
  [NATIVE_CURRENCY]: "MATIC",
  "0x2d7882bedcbfddce29ba99965dd3cdf7fcb10a1e": "TST",
  "0x326c977e6efc84e512bb9c30f76e30c160ed06fb": "LINK",
  "0x2e3b96150c4d14c07781956ce4779e2a92ca1b23": "HFS2022",
}

export const EVENT_MANAGER_ADDRESS =
  "0x16A51748274Cd17fe9De674e44654ff68EFD3936"
